define('views/modules/goal/goal',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils',
    // services
    'services/events/goal-events',
    'services/i18n',
    'services/events/calendar-events',
    // views
    'src/views/responsive-view',
    'views/parts/menu/menu-action',
    'views/modules/goal/list/goal-list',
    'views/modules/goal/list/goal-list-item',
    'views/parts/alert/alert-no-data',
    // models & collections
    'collections/goal/goals',
    'collections/calendar/days',
    // templates
    'text!templates/modules/goal/goal.html',

], function(
    // Libs
    _, Backbone, Mustache, moment, U,
    // services
    GoalEvents,
    i18n,
    CalendarEvents,
    // views
    VResponsive,
    VMenuAction,
    VGoalList,
    VGoalListItem,
    VAlertNoData,
    // models & collections
    CGoals,
    CCalendarDays,
    // templates
    TGoal
) {

    var VGoal = VResponsive.extend({
        template: TGoal,
        title: function() {
            return Mustache.render('goal:Goals', Mustache.getContext());
        },
        subtitle: "goal:Challenge yourself",

        regions: {
            root: "#goal-module",
            menu: ".menu-actions",
            list: ".goal-list",
            alert: ".alert-no-data"
        },

        initialize: function(opt) {
            this.options = opt || {};

            _.extend(this, {
                url: opt.url,
                profile: this.model,
                role: opt.role,
                group: opt.group,
                collection: new CGoals(),
                calendarDays: new CCalendarDays(null, {
                    date: moment().subtract(2, 'months'),
                    count: moment().diff(moment().subtract(2, 'months'), 'days') + 1,
                    user: this.model.id,
                })
            });

            var view = this.view = {
                menu: new VMenuAction({
                    context: this,
                    onClick: this.onActionClick,
                    radio: false,
                    collection: new Backbone.Collection([
                        { title: i18n.t('messages:tooltip-add-goal'), itemClass: 'big-action', content: '<strong>+</strong>', skipTranslation: 'true', toggle: false, callback: this.onAddGoalAction }
                    ]),
                    tooltip: { container: this.regions.root }
                }),
                list: new VGoalList({
                    collection: this.collection,
                    url: this.url,
                    profile: this.model,
                    group: this.group,
                    role: this.role,
                    calendarDays: this.calendarDays,
                    bottom: true,
                }),
                alert: new VAlertNoData({
                    title: 'goal:Add goal data',
                    subtitle: 'goal:Click on plus',
                    collection: this.collection,
                    addClass: 'alert-arrow alert-arrow-left-top',
                }),
            };

            this.listenTo(this.collection, {
                'sync': this.onCollectionSync,
                'goal:edit': this.onGoalEdit
            });
        },

        render: function() {

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.list, zone.list);

            this.collection.getFirstPage({
                user: this.profile.id
            });

            this.calendarDays.fetch({ user: this.model.id });

            return this;
        },

        // render without fetch
        _render: function() {
            this.initListener();

            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext()));

            this.generateZones();
            var view = this.view,
                zone = this.zone;

            this.assign(view.menu, zone.$menu)
                .assign(view.alert, zone.$alert)
                .assign(view.list, zone.$list);

            return this;
        },

        initListener: function() {
            this.stopListeningTo(GoalEvents);
            this.listenTo(GoalEvents, {
                "goal:update": this.onGoalUpdate,
            });
            this.listenTo(CalendarEvents, {
               'item:update': this.onGoalUpdate,
           });
        },

        /////////////
        // actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onAddGoalAction: function() {
            Backbone.history.navigate(
                Mustache.render(this.url.root + 'new/', {
                    userId: this.profile.id,
                    groupId: this.group.id
                }));
        },

        //////////////
        // events ///
        /////////////

        onCollectionSync: function(collection) {
            if (collection instanceof Backbone.Model) return;
            this._render();
        },

        onGoalEdit: function(model) {
            Backbone.history.navigate(Mustache.render(this.url.root + '{{goalId}}/', {
                userId: this.profile.id,
                groupId: this.group.id,
                goalId: model.id
            }));
        },

        onGoalUpdate: function(model) {
            this.render();
        },

        onDisable: function() {
            this.stopListeningTo(GoalEvents);
            this.stopListeningTo(CalendarEvents);
        },

    });

    return VGoal;

});

